import { createQueryParams } from '../../../utils/helpers';
import ApiUrls from '../apiUrls';
import apiClient from '../client';

export interface IParams {
  page?: number;
  categories?: number;
  quotes__scripture?: number;
  t?: number;
  date__year?: number;
  locality?: number;
  country?: number;
  // limit: number;
  // sortDirection: 'ASC' | 'DESC';
  // adminSortKey: string;
  // typeFilter: string;
  // statusFilter: string;
  // paymentMethodFilter: string;
  // toDate: string | Date;
  // fromDate: string | Date;
  // searchByUser: string;
}

export interface ICategories {
  id: number;
  aliases: string[];
  title: string;
}

export interface IPlace {
  id: number;
  combine_name: string;
}

export interface IParticipants {
  id: number;
  aliases: string[];
  photo: string | null;
  description: string;
  name: string;
}

export interface IT {
  id: number;
  title: string;
  mimetypes: string[];
}

// enum ('new', 'processed', 'published', 'archived', 'hidden', 'deleted').
// Вообще то на фронт будет отдаваться только 'published’, после того, как промодерируются все файлы
export enum EState {
  new = 'new',
  processed = 'processed',
  published = 'published',
  archived = 'archived',
  hidden = 'hidden',
  deleted = 'deleted',
}

export interface IFiileQuotes {
  book: {
    id: number;
    aliases: string[];
    title: string;
    scripture: number;
  };
  chapter: number;
  id: number;
  scripture: {
    id: number;
    aliases: string[];
    title: string;
    has_book: true;
  };
  verse: number;
}

export interface IFile {
  audio_quality: number;
  categories: ICategories[];
  date: string;
  description: null | string;
  duration: string;
  event: null | { id: number; combine_name: string }[];
  f: string;
  file_md5: string;
  file_size: number;
  id: number;
  mime_type: string;
  participants: IParticipants[];
  period: { id: number; title: string } | null;
  place: IPlace;
  quotes: IFiileQuotes[];
  resolution: null | string;
  slug: string;
  state: EState;
  t: IT;
  tags: [];
  title: string;
  audioTitle: string;
  video_quality: null;

  //Local types:
  isPlaying?: boolean;
}

export interface IFilterOption {
  selected: boolean;
  text: string;
  value: string;
}

export interface IFilter {
  name: string;
  parent: string;
  title: string;
  options: IFilterOption[];
}

export interface IDataResponse {
  count: number;
  next: null | string;
  previous: null | string;
  results: {
    files: IFile[] | [];
    filters: any | []; //TODO: fix
  };
}

export interface IArchiveFilesResponse {
  data: IDataResponse;
}

const request = (params: IParams) => {
  const query = createQueryParams<IParams>(params);
  console.log('debug-query', query);
  return (
    apiClient
      // .get<IArchiveFilesResponse>(ApiUrls.archiveFile + `?${query}`)
      .get<IDataResponse>(ApiUrls.archiveFile + `?${query}`)
      .then((response) => response)
  );
};

export default request;
